import { Badge } from '@/hen-ui/atomics/Badge';

import type { CareerExplorerSkill } from './types';

export const CareerExplorerSkillPill = ({
  label,
}: Pick<CareerExplorerSkill, 'label'>) => (
  <Badge
    variant='outline'
    size='lg'
    className='rounded-max border-secondary-700 bg-accent-200 text-secondary-700'
  >
    {label}
  </Badge>
);
